export function createResolver(schema, resolvers) {
    return {
        [schema.options.alias]: resolvers,
    };
}
